const calculateTotalMinutes = (hour, minute)=>60 * hour + minute;
const getHourData = (hour, mode)=>{
    const h = parseInt(hour);
    if ('a.m/p.m' === mode) {
        const isPm = h >= 12;
        const suffix = isPm ? ' p.m' : ' a.m';
        const converted = h % 12 || 12;
        return {
            hourStr: ('0' + converted).slice(-2),
            suffix
        };
    }
    return {
        hourStr: hour,
        suffix: ''
    };
};
const generateMinuteArray = (interval)=>{
    const minutes = [];
    for(let m = 0; m < 60; m += interval)minutes.push(('0' + m).slice(-2));
    return minutes;
};
const parseTimeValue = (value)=>{
    if (!value) return;
    const [hourStr, minuteStr] = value.trim().split(':');
    if (!hourStr || !minuteStr) return;
    const hour = parseInt(hourStr);
    const minute = parseInt(minuteStr);
    if (isNaN(hour) || isNaN(minute)) return;
    return {
        hour,
        minute
    };
};
const formatTimeDisplay = (value, mode)=>{
    const parsed = parseTimeValue(value);
    if (!parsed) return value;
    if ('a.m/p.m' === mode) {
        const h12 = parsed.hour % 12 || 12;
        const suffix = parsed.hour >= 12 ? 'p.m' : 'a.m';
        return `${('0' + h12).slice(-2)}:${('0' + parsed.minute).slice(-2)} ${suffix}`;
    }
    return value;
};
export { calculateTotalMinutes, formatTimeDisplay, generateMinuteArray, getHourData, parseTimeValue };
